export const NAME = 'resources';
export const NOT_PERSISTED = false;

export const DASHBOARD_RESOURCES_COUNT = 3;